import * as React from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';

type componentProps = {
  items: Array<{id: string, name: string}>,
  value: Array<string>,
  onChange: (event: SelectChangeEvent<Array<string>>) => void,
  label: string,
}

export const MultipleDropDownMenu = ({
    items, value, onChange, label,
}: componentProps) => {
    const obj: Record<string, string> = {};
    items.map((item) => obj[item.id] = item.name);
    return (
        <div>
            <FormControl sx={{ width: '100%' }}>
                <InputLabel>{label}</InputLabel>
                <Select
                    multiple
                    value={value}
                    onChange={onChange}
                    input={<OutlinedInput label={label} />}
                    renderValue={(s) => s.map((item) => obj[item]).join(', ')}
                    MenuProps={{
                        style: { zIndex: 35001 },
                    }}
                >
                    {items.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                            <Checkbox checked={value.indexOf(item.id) > -1} />
                            <ListItemText primary={item.name} />
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </div>
    );
};
